import React from 'react';
import AdminMasterLayout from '../../../layouts/gcadmin/adminMasterLayout/AdminMasterLayout';
import AdminBlogs from '../../../subsreens/gcadmin/manageblogs/AdminBlogs';

const ManageBlogsPage = () => {
    return(
        <AdminMasterLayout>
            <AdminBlogs/>
        </AdminMasterLayout>
    )
}

export default ManageBlogsPage;